import { createEventBus } from '@mc/event-bus'

export type WidgetType = 'Decagon AI Chat' | 'Glad App'

export type HelpCenterEvents = {
  click: {
    location: string
    action: string
    href?: string
  }

  modalViewed: {
    modalType: WidgetType
  }

  search: {
    search: string
  }
}

export const {
  EventsObserverContext: HelpCenterEventObserverContext,
  EventsProvider: HelpCenterEventProvider,
  useEventBusEvents: useHelpCenterEvents,
} = createEventBus<HelpCenterEvents>('HelpCenterEventProvider')
